import request from '@/utils/request'

let AppSettingApi = {
  /*小程序*/
  appwxDetail(data, errorback) {
    return request._get('/shop/appSetting/appwx/index', data, errorback);
  },
  /*小程序*/
  editAppWx(data, errorback) {
    return request._post('/shop/appSetting/appwx/index', data, errorback);
  },
  /*公众号*/
  appmpDetail(data, errorback) {
    return request._get('/shop/appSetting/appmp/index', data, errorback);
  },
  /*公众号*/
  editAppMp(data, errorback) {
    return request._post('/shop/appSetting/appmp/index', data, errorback);
  },
  /*app*/
  appDetail(data, errorback) {
    return request._get('/shop/appSetting/app/index', data, errorback);
  },
  /*app*/
  editApp(data, errorback) {
    return request._post('/shop/appSetting/app/index', data, errorback);
  },
  /*app开放平台*/
  appopenDetail(data, errorback) {
    return request._get('/shop/appSetting/app/pay', data, errorback);
  },
  /*app开放平台*/
  editAppOpen(data, errorback) {
    return request._post('/shop/appSetting/app/pay', data, errorback);
  },
  /*app分享*/
  appshareDetail(data, errorback) {
    return request._get('/shop/appSetting/appshare/index', data, errorback);
  },
  /*app分享*/
  editAppShare(data, errorback) {
    return request._post('/shop/appSetting/appshare/index', data, errorback);
  },
  /*app升级-列表*/
  appUpdateList(data, errorback) {
    return request._post('/shop/appSetting/appupdate/index', data, errorback);
  },
  /*app升级-新增*/
  addAppUpdate(data, errorback) {
    return request._get('/shop/appSetting/appupdate/add', data, errorback);
  },
  /*app升级-修改*/
  editAppUpdate(data, errorback) {
    return request._post('/shop/appSetting/appupdate/edit', data, errorback);
  },
  /*app升级-删除*/
  delAppUpdate(data, errorback) {
    return request._post('/shop/appSetting/appupdate/delete', data, errorback);
  },
  /*h5支付宝支付*/
  h5AlipayDetail(data, errorback) {
    return request._get('/shop/appSetting/apph5/pay', data, errorback);
  },
  /*app支付宝支付*/
  editH5Alipay(data, errorback) {
    return request._post('/shop/appSetting/apph5/pay', data, errorback);
  },
  /*支付方式*/
  payDetail(data, errorback) {
    return request._get('/shop/appSetting/app/pay', data, errorback);
  },
  /*支付方式*/
  editPay(data, errorback) {
    return request._post('/shop/appSetting/app/pay', data, errorback);
  },
  /*极光设置*/
  getJiGuang(data, errorback) {
    return request._get('/shop/setting.JiGuang/index', data, errorback);
  },
  editJiGuang(data, errorback) {
    return request._post('/shop/setting.JiGuang/index', data, errorback);
  },
  // 极光推送选项设置

  getsetMessage(data, errorback) {
    return request._get('/shop/setting.JiGuang/setMessage', data, errorback);
  },
  editsetMessage(data, errorback) {
    return request._post('/shop/setting.JiGuang/setMessage', data, errorback);
  },
  // ========================极光场景
  // 列表
  senceList(data, errorback) {
    return request._get('/shop/setting.sence/index', data, errorback);
  },
  // 详情
  senceDetail(data, errorback) {
    return request._get('/shop/setting.sence/detail', data, errorback);
  },
  // 添加
  senceAdd(data, errorback) {
    return request._post('/shop/setting.sence/add', data, errorback);
  },
  // 编辑
  senceEdit(data, errorback) {
    return request._post('/shop/setting.sence/edit', data, errorback);
  },
  // 删除
  senceDel(data, errorback) {
    return request._post('/shop/setting.sence/delete', data, errorback);
  },
  // 更改场景状态
  senceStatus(data, errorback) {
    return request._post('/shop/setting.sence/editStatus', data, errorback);
  },
  // ========================极光模板===========
  // 列表
  templateList(data, errorback) {
    return request._get('/shop/setting.template/index', data, errorback);
  },
  // 详情
  templateDetail(data, errorback) {
    return request._get('/shop/setting.template/detail', data, errorback);
  },
  // 添加
  templateJGAdd(data, errorback) {
    return request._post('/shop/setting.template/add', data, errorback);
  },
  // 编辑
  templatejgEdit(data, errorback) {
    return request._post('/shop/setting.template/edit', data, errorback);
  },
  // 删除
  templateDelete(data, errorback) {
    return request._post('/shop/setting.template/delete', data, errorback);
  },
  // 更改场景状态
  templateStatus(data, errorback) {
    return request._post('/shop/setting.template/editStatus', data, errorback);
  },
  // 手动推送
  sendToMessage(data, errorback) {
    return request._post('/shop/setting.template/sendToMessage', data, errorback);
  },
  
  // 回复列表
  replyList(data, errorback) {
    return request._get('/shop/setting.Reply/index', data, errorback);
  },
  // 设置关注回复和默认回复
  replyDefault(data, errorback) {
    return request._post('/shop/setting.Reply/default', data, errorback);
  },
  // 编辑关键词回复
  replyEdit(data, errorback) {
    return request._post('/shop/setting.Reply/edit', data, errorback);
  },
  // 添加关键词回复
  replyAdd(data, errorback) {
    return request._post('/shop/setting.Reply/add', data, errorback);
  },
  // 删除关键词回复
  replyDel(data, errorback) {
    return request._post('/shop/setting.Reply/del', data, errorback);
  },

}

export default AppSettingApi;



// WEBPACK FOOTER //
// ./src/api/appsetting.js